export default __webpack_public_path__ + "static/media/demo.b277195f.png";